/* eslint-disable complexity */
import axios from "axios";
import environmentConfig from "./EnvironmentConfig";
import sessionService from "@/services/session";
import Auth from "@aws-amplify/auth";
import moment from "moment";
import {EventBus} from "./main";


const restAPI = axios.create({
	baseURL: environmentConfig.baseUrl,
	headers: {
		"Accept": "application/json",
		"Content-Type": "application/json",
	}
});

restAPI.interceptors.request.use(function (config) {
	const language = localStorage.getItem("language") || "en";
	config.headers["Accept-Language"] = language;

	return config;
}, function (error) {
	return Promise.reject(error);
});

restAPI.interceptors.response.use(function(response) {
	return response;
}, function (error) {

	/*
	 * TODO: cannot check: error.response?.status === STATUS_CODE.UNAUTHORIZED
	 *
	 * fallback to this solution:
	 * https://github.com/axios/axios/issues/383#issuecomment-539544039
	 *
	 * Will be done with:
	 * https://codetribellc.atlassian.net/browse/KIT-967
	 */
	const networkError = error?.message === "Network Error";
	if (!networkError && error.response === undefined && Boolean(error.isAxiosError)) {
		// redirect to login if unauthorized
		sessionService.logout();
		EventBus.$emit("reloadData");
		return Promise.reject(error);
	}

	if (Number(localStorage.getItem("exptime")) < moment().unix()) {
		const SECONDS = 1000;
		localStorage.setItem("exptime", moment().unix() + SECONDS);

		Auth.currentSession().then((response) => {
			localStorage.setItem("exptime", response.accessToken.payload.exp);
			localStorage.setItem(localStorage.getItem("refkey") + ".accessToken", response.accessToken.jwtToken);
			localStorage.setItem(localStorage.getItem("refkey") + ".idToken", response.idToken.jwtToken);
			localStorage.setItem(localStorage.getItem("refkey") + ".refreshToken", response.refreshToken.token);
			EventBus.$emit("reloadData");
		});

	}
	else
		return Promise.reject(error);


});

export default restAPI;

